/**
 * @file: index.tsx
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 *
 * The 2×2 KPI grid above the reservation cards: total / upcoming / arrived /
 * converted, wired to the search-scoped `ReservationStats` counts.
 */

import { KpiCard } from '@euler/app/flows/leads/pages/list/components/kpi/KpiCard';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { ReservationStats } from '@euler/model/reservation/types';
import {
  CalendarClock,
  CarFront,
  CheckCircle2,
  ListChecks,
} from 'lucide-react-native';
import { memo } from 'react';
import { View } from 'react-native';

export const ReservationKpiGrid = memo(
  ({ stats }: { stats: ReservationStats | undefined }) => {
    const { rpx } = useResponsiveContext();
    const row = { flexDirection: 'row', gap: rpx(8) } as const;
    return (
      <View
        style={{
          marginHorizontal: rpx(16),
          marginBottom: rpx(12),
          gap: rpx(8),
        }}
      >
        <View style={row}>
          <KpiCard
            value={stats?.total}
            label="全部预约"
            icon={ListChecks}
            iconColor="#0066FF"
            iconBg="#EEF5FF"
          />
          <KpiCard
            value={stats?.upcoming}
            label="待到店"
            icon={CalendarClock}
            iconColor="#C2410C"
            iconBg="#FFF7ED"
          />
        </View>
        <View style={row}>
          <KpiCard
            value={stats?.arrived}
            label="已到店"
            icon={CarFront}
            iconColor="#0369A1"
            iconBg="#E0F2FE"
          />
          <KpiCard
            value={stats?.converted}
            label="已开单"
            icon={CheckCircle2}
            iconColor="#047857"
            iconBg="#ECFDF3"
          />
        </View>
      </View>
    );
  },
);
